import React from 'react'
import {Lang} from 'yougile-lang'
import {globals} from '@extensions/globals-base'
import {
  TwEmptyDescContainer,
  TwEmptyDescHint,
  TwEmptyImage,
  TwEmptyLabel,
  TwEmptySmallContainer
} from './containers'
import EmptyDescImgDark from './icons/empty-desc-dark.svg'
import EmptyDescImgLight from './icons/empty-desc-light.svg'

export const EmptyDescription = () => {
  const isDark = globals.theme === 'dark'
  const Image = isDark ? <EmptyDescImgDark /> : <EmptyDescImgLight />

  return (
    <TwEmptyDescContainer>
      <TwEmptySmallContainer>
        <TwEmptyImage>{Image}</TwEmptyImage>
        <TwEmptyLabel>{Lang.msg.descriptionIsEmpty}</TwEmptyLabel>
        <TwEmptyDescHint>{Lang.msg.descriptionIsEmptyHint}</TwEmptyDescHint>
      </TwEmptySmallContainer>
    </TwEmptyDescContainer>
  )
}
